export default "5977df9f688b5bc5.svg"